import { render, staticRenderFns } from "./HoursUserSelector.vue?vue&type=template&id=0134a650&"
import script from "./HoursUserSelector.vue?vue&type=script&lang=js&"
export * from "./HoursUserSelector.vue?vue&type=script&lang=js&"
import style0 from "./HoursUserSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports